import React, { useEffect, useState } from 'react';
import { Typography, Tabs, Tab, Box } from '@mui/material';
import LoginContainer from '../components/authentication/LoginContainer';
import ForgotPasswordContainer from '../components/authentication/ForgotPasswordContainer';
import { getCurrentUser } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    getCurrentUser()
      .then(() => navigate('/'))
      .catch(() => {});
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '90vh',
        backgroundColor: 'background.default',
        color: 'text.primary',
      }}
    >
      <Tabs
        value={tabValue}
        onChange={(_, newValue) => setTabValue(newValue)}
        centered
        textColor="inherit"
        TabIndicatorProps={{ sx: { backgroundColor: '#d32f2f' } }}
      >
        <Tab label="Log In" />
        <Tab label="Forgot your password?" />
      </Tabs>

      {tabValue === 0 ? <LoginContainer /> : <ForgotPasswordContainer />}

      <Typography
        variant="body2"
        align="center"
        sx={{ marginTop: 20, color: 'text.secondary' }}
      >
        BWI 10 Review &nbsp;&nbsp; Version: 2.5.1
      </Typography>
    </Box>
  );
};

export default Login;
